<template>
  <div v-if="user">
    <b-img
      :src="require('@/assets/images/logo_centered.svg')"
      width="300"
      class="rounded-0"
    />

    <div class="mt-5">
      <h4 class="font-weight-bold">Verify Your Email</h4>
      <p class="mt-3">
        For security, we need to verify your email address. Type in the
        <br />verification code sent to your email.
      </p>
    </div>

    <b-form @submit.prevent="onSubmitInfo" class="mt-4">
      <b-form-group id="input-group-1" class="col-12">
        <b-form-input
          id="input-1"
          v-model="form.token"
          class="input-effect"
          :class="form.token ? 'has-content' : ''"
          :disabled="form.$busy"
          type="text"
          autofocus
          required
        ></b-form-input>
        <label>Verification code</label>

        <div
          class="input-error"
          v-if="form.$getError('token') || form.$errorMessage"
        >
          {{
            form.$getError('token')
              ? form.$getError('token')[0]
              : form.$errorMessage
          }}
        </div>
      </b-form-group>

      <div class="mt-4">
        <b-button type="submit" variant="primary" block>
          <b-spinner small v-if="form.$busy" />
          <span>Verify</span>
        </b-button>
      </div>

      <div class="mt-4">
        <p class="form-link" @click="onNext">
          <b>Skip for now</b>
        </p>
      </div>

      <div class="mt-5">
        <template v-if="resendSuccessful">
          Verification code has been sent to your email!
        </template>
        <template v-else>
          <template v-if="resend.$busy">
            Resending verification code, pleae wait a while...
          </template>
          <template v-else>
            Forgot your verification code? Click
            <span class="form-link" @click="onResend">here</span>
          </template>
        </template>
      </div>
    </b-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'

export default {
  data() {
    return {
      resend: new Form({}),
      resendSuccessful: false,
      form: new Form({
        via: 'email',
        token: ''
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser',
      requestVerificationEmail: 'auth/requestVerificationEmail'
    }),

    onNext() {
      this.$router.replace({
        name:
          !this.user.first_name &&
          !this.user.last_name &&
          !this.user.business_contact_number
            ? 'auth.onboarding-page'
            : 'job.feed-page'
      })
    },

    async onSubmitInfo() {
      if (this.form.$busy) return
      this.form.$setLoading(true)

      await this.$api
        .post('auth/verification/verify', this.form)
        .then(({ data }) => {
          this.onNext()
        })
        .catch(error => {
          this.form.$handleError(error)
          this.form.$setLoading(false)
        })
    },

    async onResend() {
      if (this.resend.$busy) return
      this.resend.$setLoading(true)

      await this.requestVerificationEmail()
        .then(() => {
          this.resendSuccessful = true
        })
        .catch(error => {
          this.resend.$handleError(error)
          this.resend.$setLoading(false)

          this.$bvToast.toast(this.resend.$errorMessage, {
            title: 'Failure to resend verification code',
            variant: 'danger',
            solid: true
          })
        })
    },

    async isVerified() {
      if (!this.user) {
        await this.getAuthenticatedUser()
      }

      if (!this.user) {
        this.$router.push({
          name: 'auth.login-page'
        })
      } else if (this.user.email_verified) {
        this.$router.replace({
          name: 'job.feed-page'
        })
      }
    }
  },

  created() {
    this.isVerified()
  }
}
</script>
<style lang="scss" scoped>
.form-link {
  color: #106fdc;
  font-weight: bold;
  cursor: pointer;
}
</style>
